import { dateFormat } from "highcharts";
import API from "../BaseURL";
import { getModemByExploitation } from "../exploitations/modems";
import { now } from "moment";

const configJson = {
    headers: {
      "content-type": "application/json",
    },
  };


export async function getAllSoils() {
    const res = API.get(`/soils/`, configJson);
    return res;
}

export async function getSoilInfo(soil_id) {
    const res = API.get(`/soils/${soil_id}`, configJson);
    return res;
}

export async function createSoil(data) {
    const res = API.post(`/soils/`, data, configJson);
    return res;
}

export async function updateSoil(soil_id, data) {
    const res = API.put(`/soils/${soil_id}/`, data, configJson);
    return res;
}

export async function deleteSoil(soil_id) {
    const res = API.delete(`/soils/${soil_id}/`, configJson);
    return res;
}


export async function getSoilByModem(modem_id) {
    const res = API.get(`/soils/modem/${modem_id}`, configJson);
    return res;
}

export async function getSoilByExploitation(exploitation_id) {
    const modems = await getModemByExploitation(exploitation_id);
    const soils = [];
    for (let modem of modems) {
        const res = await getSoilByModem(modem.modem_id);
        soils.push(...res.data);
    }
    return soils;
}



export async function getSoilByExploitationAndPointNumber(exploitation_id, point_number, start_date, end_date) {
    const modems = await getModemByExploitation(exploitation_id);
    const soils = [];
    if (start_date === null || start_date === undefined) {
        // if the start date is null, we set it to 15 days ago
        start_date = new Date();
        start_date.setDate(start_date.getDate() - 15);
        start_date = dateFormat(start_date, "yyyy-mm-dd");
    }
    if (end_date === null || end_date === undefined) {
        // if the end date is null, we set it to now
        end_date = new Date();
        end_date = dateFormat(end_date, "yyyy-mm-dd");
    }
    
    for (let modem of modems) {
        const res = API.get(`/soils/modem/${modem.modem_manual_id}/${point_number}/${start_date}/${end_date}`, configJson);
        soils.push(...(await res).data);
    }
    return soils;
}
